"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = require("./styled");
const download_quote_1 = __importDefault(require("./download-quote"));
const start_trial_1 = __importDefault(require("./start-trial"));
const contact_1 = __importDefault(require("./contact"));
const compliance_documents_1 = __importDefault(require("./compliance-documents"));
const PortalButtons = ({ quotePortal }) => {
    const latestQuote = quotePortal.quotes[0];
    if (!latestQuote) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(styled_1.StyledQuoteButtonsWrapper, { children: [(0, jsx_runtime_1.jsx)(download_quote_1.default, { quotePortal: quotePortal }), (0, jsx_runtime_1.jsx)(start_trial_1.default, { quotePortal: quotePortal }), (0, jsx_runtime_1.jsx)(contact_1.default, { quote: latestQuote }), (0, jsx_runtime_1.jsx)(compliance_documents_1.default, {})] }));
};
exports.default = PortalButtons;
